export default __webpack_public_path__ + "static/media/shoppingWithin.399819b8.svg";